import { IconProps } from '@/modules/defines/interface';

const Stair = ({ fill, width, height }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '32'}
      height={height || '32'}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3913 5H23.1739C21.7391 5 20.5652 5.9 20.5652 7V10H16.6522C15.2174 10 14.0435 10.9 14.0435 12V15H10.1304C8.69565 15 7.52174 15.9 7.52174 17V20H3.6087C2.17391 20 1 20.9 1 22V24C1 25.1 2.17391 26 3.6087 26H28.3913C29.8261 26 31 25.1 31 24L31 20L31 15V10V7C31 5.9 29.8261 5 28.3913 5Z"
        fill={fill}
      />
    </svg>
  );
};

export default Stair;
